const headerHoverPopups = {
    btns: Array.from(document.querySelectorAll('.jsPopupBtns')),
    wraps: Array.from(
      document.querySelectorAll('.jsPopupWraps'),
    ),
    overlay: document.getElementById('jsPopupOverlay') ,
  
    init() {

        if(window.screen.width >= 1199) {
          this.setHoverState();
          this.removeHoverState();
        }

        this.setClosePopupListener();
    },
  
    setHoverState() {
      this.btns.forEach((btn) => {
        btn.addEventListener('mouseenter', () => {
          this.handleHover(btn);
        });
      });
    },
  
    handleHover(activeBtn) {
      const popupId = activeBtn.getAttribute('data-popup');
  
      setTimeout(() => {
        this.btns.forEach((btn) => {
          const wrap = this.getWrapForButton(btn);
          const wrapPopupId = wrap.getAttribute('data-popup');
  
          if (popupId === wrapPopupId) {
            btn.classList.add('activeClass');
            wrap.classList.add('activeClass');
            this.overlay.classList.add('activeClass');
          } else {
            btn.classList.remove('activeClass');
            wrap.classList.remove('activeClass');
          }
        });
      }, 150);
    },
  
    getWrapForButton(btn) {
      const btnPopupId = btn.getAttribute('data-popup');
      return this.wraps.find(
        (wrap) => wrap.getAttribute('data-popup') === btnPopupId,
      ) ;
    },
  
    removeHoverState() {
      window.addEventListener('mouseover', this.handleMouseOut.bind(this));
    },
  
    handleMouseOut(e) {
      const target = e.target ;
  
      if (!this.isHoveredElement(target)) {
        setTimeout(() => {
          this.btns.forEach((btn) => {
            const wrap = this.getWrapForButton(btn);
            btn.classList.remove('activeClass');
            wrap.classList.remove('activeClass');
            this.overlay.classList.remove('activeClass');
          });
        }, 150);
      }
    },
  
    isHoveredElement(target) {
      return [...this.btns, ...this.wraps].some(
        (element) => element === target || element.contains(target),
      );
    },
  
    setClosePopupListener() {
      if (this.overlay) {
        this.overlay.addEventListener('click', () => {
          this.closePopups();
        });
      }
  
      const closeButtons = document.querySelectorAll(
        '.close-popup',
      );
      closeButtons.forEach((closeBtn) => {
        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.closePopups();
        });
      });
    },
  
    closePopups() {
      this.btns.forEach((btn) => {
        btn.classList.remove('activeClass');
      });
      this.wraps.forEach((wrap) => {
        wrap.classList.remove('activeClass');
      });
      this.overlay.classList.remove('activeClass');
    },
  };
  
  export default headerHoverPopups;